
import http from '@/features/shared/http/client';
import {
    StoryboardFrame,
    StoryboardFrameRegenerationOptions,
    StoryboardGenerationOptions,
    StoryboardImageGenerationOptions,
} from '@/features/storyboard/types/storyboard.types';

export class StoryboardAIService {
    async generateStoryboard(options: StoryboardGenerationOptions): Promise<StoryboardFrame[]> {
        const response = await http.post<StoryboardFrame[]>('/generateStoryboardAI', { options });
        return response.data;
    }

    /**
     * Generate an image for a specific frame and upload it to Firebase Storage.
     * Returns the public download URL.
     */
    async generateFrameImage(
        options: StoryboardImageGenerationOptions
    ): Promise<{ success: boolean; imageUrl: string }> {
        const response = await http.post<{ success: boolean; imageUrl: string }>(
            '/generateStoryboardImage',
            { options }
        );
        return response.data;
    }

    async regenerateSingleFrame(
        options: StoryboardFrameRegenerationOptions
    ): Promise<StoryboardFrame> {
        const response = await http.post<StoryboardFrame>('/regenerateSingleFrame', { options });
        return response.data;
    }
}

export const storyboardAIService = new StoryboardAIService();
